import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { FONT_WEIGHT } from '../../foundations/typography';
import { ActionBottomSheetVariantType, InputVariantType, LoaderVariantType, PopoverVariantType, TextVariantType, } from '../variants';
const getBoxShadow = (FOUNDATIONS) => {
    // SHADOW_40
    return `0rem ${FOUNDATIONS.spacing_75} ${FOUNDATIONS.spacing_100} ${FOUNDATIONS.spread_negative_50} ${FOUNDATIONS.color_effect_shadow_drop_100}`;
};
export const commonStyles = (FOUNDATIONS) => ({
    inputVariant: InputVariantType.REGULAR,
    label: {
        font_variant: TextVariantType.FONT_PARAGRAPH_200,
    },
    labelContainer: {
        margin_bottom: FOUNDATIONS.spacing_150,
    },
    popoverVariant: {
        [DeviceBreakpointsType.DESKTOP]: PopoverVariantType.INPUT_SEARCH,
        [DeviceBreakpointsType.TABLET]: PopoverVariantType.INPUT_SEARCH,
        [DeviceBreakpointsType.MOBILE]: PopoverVariantType.INPUT_SEARCH,
    },
    useActionBottomSheet: {
        [DeviceBreakpointsType.DESKTOP]: false,
        [DeviceBreakpointsType.TABLET]: true,
        [DeviceBreakpointsType.MOBILE]: true,
    },
    actionBottomSheetVariant: ActionBottomSheetVariantType.INPUT_SEARCH,
    searchListContainer: {
        background_color: FOUNDATIONS.color_comp_forms_input_bg,
        border_radius: FOUNDATIONS.radius_comp_containers_contextmenu_radiussize,
        margin_top: FOUNDATIONS.spacing_100,
        [DeviceBreakpointsType.DESKTOP]: {
            box_shadow: getBoxShadow(FOUNDATIONS),
        },
    },
    // WARNING - This extra height represents the litsOptions inner padding
    // For now, this calc is being updated manually. It will set automatically when new inputs are created
    searchListExtraHeight: `calc(2 * ${FOUNDATIONS.spacing_200})`,
    noResultsTextContainer: {
        padding: FOUNDATIONS.spacing_300,
        background_color: FOUNDATIONS.color_comp_forms_input_bg,
    },
    noResultsText: {
        font_variant: TextVariantType.FONT_PARAGRAPH_200,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_comp_forms_input_filled_font,
    },
    loadingText: {
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        font_weight: FONT_WEIGHT.font_light,
        color: FOUNDATIONS.color_neutral_font_50,
    },
    loaderExpandedContainer: {
        background_color: FOUNDATIONS.color_comp_forms_input_bg,
        padding: `${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_300}`,
    },
    loaderContractedContainer: {
        background_color: FOUNDATIONS.color_comp_forms_input_bg,
        padding_bottom: FOUNDATIONS.spacing_300,
        gap: FOUNDATIONS.spacing_150,
    },
    loader: {
        variant: LoaderVariantType.SECONDARY,
        width: FOUNDATIONS.size_250,
    },
});
//# sourceMappingURL=commonStyles.js.map